import { useQuery } from '@tanstack/react-query'
import { BACKGROUND_REFETCH_MS, queryKeys } from '@/api/queryKeys'
import { fetchAllocation, fetchCalendarAllocation } from '@/api/allocation'
import type { AllocationResult } from '@/lib/allocation'
import { toISODate } from '@/lib/dates'

/** Reactive allocation over the last N days (default 30). */
export function useAllocation(windowDays = 30): AllocationResult | undefined {
  const { data } = useQuery({
    queryKey: queryKeys.allocation(windowDays),
    queryFn: () => fetchAllocation(windowDays),
    refetchOnWindowFocus: true,
    refetchInterval: BACKGROUND_REFETCH_MS,
  })
  return data
}

/** Reactive allocation for an explicit date range (used by the calendar view). */
export function useCalendarAllocation(from: Date, to: Date): AllocationResult | undefined {
  const fromStr = toISODate(from)
  const toStr = toISODate(to)
  const { data } = useQuery({
    queryKey: queryKeys.calendarAllocation(fromStr, toStr),
    queryFn: () => fetchCalendarAllocation(fromStr, toStr),
    refetchOnWindowFocus: true,
  })
  return data
}
